import { MccsRoles, PaymentsService } from '@/@types/generated'
import { hasRole } from '@/components/Atoms/Permissions'
import { Button } from '@/components/ui/button'
import { PaymentsFeature } from '@/lib/features'
import { InternalRoles } from '@/lib/utils'
import { buildPath } from '@/routes'
import { useEffect } from 'react'
import { Link } from 'react-router'
import { useGlobalNotices } from '../global-notices'
import { useAuth } from '../useAuth'

export const OutstandingBalanceNoticeKey = 'outstanding-balance'

export function OutstandingBalanceNotice() {
  // Hooks
  const { addNotice } = useGlobalNotices()
  const { user } = useAuth()

  useEffect(() => {
    // No payments feature
    if (!PaymentsFeature.isEnabled(user)) return

    // Hide for internal roles, and LAs
    if (
      hasRole(
        [
          ...InternalRoles,
          MccsRoles.LICENSING_AGENCY_OWNER,
          MccsRoles.LICENSING_AGENCY_USER,
        ],
        user
      )
    )
      return

    // Logic to check for outstanding balance and show notice
    PaymentsService.getBalance().then(({ balance }) => {
      if (balance <= 0) return

      // Show global notice about outstanding balance
      addNotice({
        type: 'warning',
        key: OutstandingBalanceNoticeKey,
        message: (
          <div className="flex flex-1 items-center justify-between gap-4">
            You have an outstanding balance on your account. Please make a
            payment as soon as possible.
            <Button asChild size="sm">
              <Link to={buildPath('/payments/process')}>Make a Payment</Link>
            </Button>
          </div>
        ),
      })
    })
  }, [addNotice, user])

  return null
}
